import React, { useEffect, useState } from "react";
import "./App.scss";
import Routing from "./Routes";
import LanguageContextProvider from "./context/Language";
import ReorderableTable from "./components/abc";
import useAuth from "./hooks/useAuth";
import { useAppDispatch } from "./hooks/store";
import { usePostLogoutMutation } from "./services/auth";
import { removeFromStorage } from "./helpers/storage";
import { STORAGE_KEYS } from "./constants/storageKeys";
import { resetAuth } from "./reducers/authSlice";
import secureLocalStorage from "react-secure-storage";
import { useNavigate } from "react-router-dom";
import { User } from "./types/User";
import { ROLES } from "./utils/enums";
import { showToast } from "./constants/toasts";
import { toast } from "react-toastify";
import { firebaseCloudMessaging } from "./utils/firebase";

const App = () => {
  const user = useAuth() as User;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [logoutMethod] = usePostLogoutMutation();
  const [hasLoggedOut, setHasLoggedOut] = useState(false);

  const handleLogout = async () => {
    try {
      const result = await logoutMethod({}).unwrap();
      if (result?.statusCode === 200) {
        toast.info(
          "You have been logged out because your account is blocked by Admin"
        );
        removeFromStorage(STORAGE_KEYS.token);
        dispatch(resetAuth());
        secureLocalStorage.removeItem("permissions");
        secureLocalStorage.removeItem("role");
        removeFromStorage(STORAGE_KEYS.tempToken);
        navigate("/", { replace: true });
      }
    } catch (error) {
      console.log(error);
    }
  };

  // console.log(user, "userData");
  // useEffect(() => {
  //   if (hasLoggedOut) {
  //     handleLogout();
  //   }
  // }, [hasLoggedOut]);
  // console.log(hasLoggedOut, "hasLoggedOut");
  useEffect(() => {
    async function setToken() {
      try {
        const fcmToken = await firebaseCloudMessaging.init();
        if (fcmToken) {
          console.log("fcm_Token", fcmToken);
        }
      } catch (error) {
        console.log(error);
      }
    }
    setToken();

    // Event listener that listens for the push notification event in the background
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        try {
          event?.source?.postMessage("Hi client");
          console.log("event for the service worker", event);

          return toast(
            <div style={{ height: "100%" }}>
              <div
                style={{ color: "#820000" }}
                onClick={() => navigate("/recieved-notifications")}
              >
                {event?.data?.data?.title || ""}
              </div>
              <div
                style={{ color: "#1d1d1d", paddingTop: "10px" }}
                onClick={() => navigate("/manage-notifications")}
              >
                {event?.data?.data?.body || ""}
              </div>
            </div>
          );
        } catch (e) {
          console.log(e, "error");
          return e;
        }
      });
    }

    if ("permissions" in navigator) {
      navigator.permissions
        .query({ name: "notifications" })
        .then(function (notificationPerm) {
          notificationPerm.onchange = function () {
            if (notificationPerm.state === "granted") {
              setToken();
              if (window) {
                window.location.reload();
              }
            }
          };
        });
    }
    return () => {
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.removeEventListener("message", (e) =>
          console.log(e)
        );
      }
    };
  }, []);
  useEffect(() => {
    if (user?.isBlocked) {
      handleLogout();
    }
    // setHasLoggedOut(user?.isBlocked);
  }, [user?.isBlocked]);
  return (
    <LanguageContextProvider>
      {/* <ReorderableTable /> */}
      <Routing />
    </LanguageContextProvider>
  );
};

export default App;
